import React from 'react';
import { useDataGrid } from '..';

export interface TDataGridTableBodyRowSelectProps {
  id: string;
}

const DataGridTableBodyRowSelect = ({
  id,
}: TDataGridTableBodyRowSelectProps) => {
  const { selectedRowIds, toggleRowSelection } = useDataGrid();
  const isSelected = selectedRowIds.has(id);

  return (
    <td>
      <label
        htmlFor={`row-select-${id}`}
        className="sr-only"
        aria-label="Select row"
      >
        Select row
      </label>
      <input
        type="checkbox"
        id={`row-select-${id}`}
        className="checkbox checkbox-sm cursor-pointer"
        checked={isSelected}
        onChange={() => toggleRowSelection(id)}
      />
    </td>
  );
};

export { DataGridTableBodyRowSelect };
